import * as Yup from 'yup';
import { DictEmploymentPosition, Employment, Subject } from '@models';

export function useValidationSchema() {
  return Yup.object<Employment>().shape({
    subject: Yup.mixed<Subject>().nullable().required(),
    positions: Yup.array<DictEmploymentPosition>().nullable().required(),
  }) as Yup.Schema<Employment>;
}
